import React, { useState, useEffect } from 'react';
import { Card, CardHeader, Col, DropdownItem, DropdownMenu, DropdownToggle, UncontrolledDropdown } from 'reactstrap';
import ReactApexChart from 'react-apexcharts';
import axios from '../../../utills/api';

const SalesForecast = () => {
  const [chartData, setChartData] = useState([]);
  const [selectedMonth, setSelectedMonth] = useState('Nov 2021');
  const [loading, setLoading] = useState(true);

  // Fetch bookings from API
  const fetchBookings = async () => {
    try {
      const res = await axios.get('/bookings');
      console.log('📦 Full API Response:', res.data);

      const data = Array.isArray(res.data) 
        ? res.data 
        : Array.isArray(res) 
          ? res 
          : [];


        console.log("✅ Extracted bookings data:", data);

      // Count bookings by source
      const walkinCount = data.filter(b => b.source?.toLowerCase() === 'walkin').length;
      const websiteCount = data.filter(b => b.source?.toLowerCase() === 'website').length;
      const onlineCount = data.filter(
        b => b.source?.toLowerCase() !== 'walkin' && b.source?.toLowerCase() !== 'website'
      ).length;

      console.log('📊 Source Counts:', { walkinCount, websiteCount, onlineCount });

      // Set chart series
      setChartData([
        {
          name: 'Bookings',
          data: [walkinCount, websiteCount, onlineCount],
        },
      ]);
    } catch (error) {
      console.error('❌ Error fetching bookings:', error);
      setChartData([{ name: 'Bookings', data: [0, 0, 0] }]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchBookings();
  }, [selectedMonth]);

  const onChangeChartPeriod = period => {
    setSelectedMonth(period);
    // Future: API filter by month
  };

  // Chart options
const chartOptions = {
  chart: { type: 'bar', height: 341, toolbar: { show: false } },
  plotOptions: { 
    bar: { 
      horizontal: false, 
      columnWidth: '65%',
      distributed: true // ✅ distribute colors per bar
    } 
  },
  stroke: { show: true, width: 5, colors: ['transparent'] },
  xaxis: {
    categories: ['Walkin', 'Website', 'Online'],
    axisTicks: { show: false },
    title: { text: 'Booking Source', style: { color: '#78909C', fontSize: '12px', fontWeight: 400 } },
  },
  yaxis: {
    labels: { formatter: value => value },
    min: 0,
    tickAmount: 4,
  },
  fill: { opacity: 1 },
  legend: { show: true, position: 'bottom', horizontalAlign: 'center', fontWeight: 500 },
  colors: ['#3cd188', '#efae4e', '#f7666e'], // ✅ green, blue, red
};



  return (
    <React.Fragment>
      <Col lg={3} md={6}>
        <Card>
          {/* ===== Card Header + Dropdown ===== */}
          <CardHeader className="align-items-center d-flex">
            <h4 className="card-title mb-0 flex-grow-1">Sales Forecast</h4>
            <div className="flex-shrink-0">
              <UncontrolledDropdown className="card-header-dropdown">
                <DropdownToggle tag="a" className="text-reset dropdown-btn" role="button">
                  <span className="fw-bold text-uppercase fs-12">Sort by: </span>
                  <span className="text-muted">
                    {selectedMonth.charAt(0).toUpperCase() + selectedMonth.slice(1)}
                    <i className="mdi mdi-chevron-down ms-1"></i>
                  </span>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-start">
                  {['Oct 2021', 'Nov 2021', 'Dec 2021', 'Jan 2022'].map(month => (
                    <DropdownItem
                      key={month}
                      onClick={() => onChangeChartPeriod(month)}
                      className={selectedMonth === month ? 'active' : ''}
                    >
                      {month}
                    </DropdownItem>
                  ))}
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          </CardHeader>

          {/* ===== Card Body ===== */}
          <div className="card-body pb-0">
            {loading ? (
              <p className="text-center text-muted">Loading chart...</p>
            ) : (
              <ReactApexChart
                options={chartOptions}
                series={chartData.length ? chartData : [{ data: [] }]}
                type="bar"
                height="341"
              />
            )}
          </div>
        </Card>
      </Col>
    </React.Fragment>
  );
};

export default SalesForecast;
